import React from 'react';
import styles from './PageLayout.module.css';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';

/**
 * @component PageLayout
 * @param {boolean} [noHeaderOffset] - 랜딩처럼 헤더가 콘텐츠 위에 오버레이될 때 true
 */
function PageLayout({ children, noHeaderOffset = false }) {
  return (
    <div className={styles.pageLayout}>
      <Header />
      <main className={noHeaderOffset ? styles.mainFull : styles.main}>
        {children}
      </main>
      <Footer />
    </div>
  );
}

export default PageLayout;
